import { render, staticRenderFns } from "./payment-component-new.vue?vue&type=template&id=6b588ba6&scoped=true&"
import script from "./payment-component-new.vue?vue&type=script&lang=js&"
export * from "./payment-component-new.vue?vue&type=script&lang=js&"
import style0 from "./payment-component-new.vue?vue&type=style&index=0&id=6b588ba6&scoped=true&lang=css&"
import style1 from "./payment-component-new.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b588ba6",
  null
  
)

export default component.exports